import { GoogleAnalytics } from '@/components/common/GoogleAnalytics';
import { AppProviders } from '@/providers/AppProviders';
import { AppRouter } from '@/routes';

export default function App() {
  return (
    <AppProviders>
      <GoogleAnalytics />
      <AppRouter />
    </AppProviders>
  );
}
